<template>
    <div class="hstack gap-1 h-100">
        <label v-if="label != ''">{{ label }}</label>
        <div v-if="items != undefined && items.length > 0">
            <input class="form-control h-100" :list="randomId" placeholder="Type to search..." v-model="filterValue" @change="handleChange">
            <datalist :id="randomId">
                <option v-for="item in items" v-bind:value="item.text"></option>
            </datalist>
        </div>        
        <input class="form-control h-100" placeholder="" v-model="filterValue" @keyup="handleChange" v-else>
    </div>
</template>
<script lang="ts">
import { defineComponent, watch, ref, defineEmits } from 'vue';    
import type { PropType } from 'vue';
import { BFieldSelection } from '../BFilterEditor/BFilterEditor.types';

export default defineComponent({
    props: {
        items: {
            readonly: false,
            default: {},
            type: Object as PropType<BFieldSelection[]>
        },
        disabled: {
            readonly: true,
            default: false,
            type: Boolean
        },
        modelValue: {
            readonly: true,
            default: "",
            type: String
        },
        label: {
            readonly: true,
            default: "",
            type: String
        }
    },
    setup(props, context) {
        var filterValue = ref(props.modelValue);

        const emit = defineEmits<{
                (event: 'change', value: string): void
            }>();
            
        function handleChange(event:any) {
            context.emit('change', filterValue.value);
        };

        const randomId = `datalist${Math.ceil(Math.random() * (1000 - 1) + 1)}`;
        return { filterValue, handleChange, randomId };
    },
    watch: {
        'modelValue': function(newVal, oldVal){
            this.filterValue = newVal;
        }
    }
});
</script>